package com.cybersoftsolution.cybersoftsolutionweb.components.dropDowns

import androidx.compose.runtime.Composable
import com.cybersoftsolution.cybersoftsolutionweb.models.Category
import com.cybersoftsolution.cybersoftsolutionweb.models.Theme
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.GeneralKind
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.Ul

@Composable
    fun CategoryDropdown(
        modifier: Modifier = Modifier,
        style: CssStyle<GeneralKind>,
        id: String,
        placeholder : String = "",
        selectedCategory: Category? = Category.NoCategory,
        onCategorySelected: (Category) -> Unit = {}
    ){





        Box(
            modifier = style.toModifier()
                .then(modifier)
                .classNames("dropdown")
                .cursor(Cursor.Pointer)
                .attrsModifier {
                    attr("data-bs-toggle", "dropdown")
                }
                .zIndex(9)

        ) {
            Row(
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.SpaceBetween,
                modifier = Modifier
                    .fillMaxSize()
            ) {
                SpanText(
                    text = if (selectedCategory == Category.NoCategory || selectedCategory == null) {
                        placeholder
                    } else selectedCategory.name,
                    modifier = Modifier
                        .fontSize(14.px)
                        .thenIf(
                            condition = selectedCategory == Category.NoCategory,
                            other = Modifier.color(Theme.HalfBlack.rgb)
                        )
                )

                Box(
                    modifier = Modifier
                        .classNames("dropdown-toggle")
                )

                Ul(
                    attrs = Modifier
                        .fillMaxWidth()
                        .classNames("dropdown-menu")
                        .toAttrs()
                ) {
                    Category.entries.forEach { category ->
                        Li {
                            A(
                                attrs = Modifier
                                    .classNames("dropdown-item")
                                    .color(Colors.Black)
                                    .fontSize(14.px)
                                    .cursor(Cursor.Pointer)
                                    .onClick { onCategorySelected(category) }
                                    .toAttrs()
                            ) {
                                Text(value = category.name)
                            }
                        }
                    }

                }

            }


        }


    }